import { createFileRoute } from "@tanstack/react-router"
import { AuthContainer } from "./-components/auth-container"
import { useTranslation } from "react-i18next"
import { LoginForm } from "./-components/login-form"

type loginError =
  | "authentication_failed"
  | "access_denied"
  | "remote_failure"
  | "user_provisioning_failed"

export const Route = createFileRoute("/authenticate/login")({
  validateSearch: (search: { returnUrl?: string; error?: loginError }) =>
    search,
  component: Login,
  beforeLoad(ctx) {
    return { getTitle: () => ctx.context.t && ctx.context.t("Login") }
  },
})

export function Login() {
  const { t } = useTranslation("app_server")

  return (
    <AuthContainer title={t("Login")}>
      <LoginForm />
    </AuthContainer>
  )
}
